/**
 * Created by Ram on 21/03/2017.
 */

import React, { Component } from "react";
import DevicesList from './CreateCluster/DevicesList'
import SelectedDevicesList from './CreateCluster/SelectedDevicesList'

class CreateCluster extends Component {
  render() {
    let errorMessage = null;
    let success = null;
    let serverError = null;

    const { devices, selectedDevices, sortAsc, sort, sortDevicesAsc } = this.props.loadData
    const { updateSortState, updateClusterDevice, removeDevice } = this.props


    if (this.props.loadData.error) {
      errorMessage = (
        <div className="alert alert-danger"> {this.props.loadData.error} </div>
      );
    }

    if (this.props.loadData.success) {
      success = (
        <h4 className="alert alert-success col-sm-10 col-sm-offset-1 text-center">
          {this.props.loadData.success}
        </h4>
      );
    }

    if (this.props.loadData.serverError) {
      serverError = (
        <div className="alert alert-danger col-sm-4 col-sm-offset-4 text-center">
          {" "}
          {this.props.loadData.serverError}{" "}
        </div>
      );
    }

    return (
      <div>
        <ol className="breadcrumb">
          <li>
            <a onClick={this.props.navigator.requestDeviceManagement}>
              Device Management
            </a>
          </li>
          <li>
            <a onClick={this.props.navigator.requestClusterManagement}>
              Cluster Management
            </a>
          </li>
          <li className="active">Create Cluster</li>
        </ol>

        <div className="create-cluster-main-div pull-left">
          <div className="search-device-list">
            <div className="row">
              <div className="col-sm-4">
                <span className="block-heading">
                  Available Devices ({devices.length})
                </span>
              </div>
              <div className="col-sm-4">
                <button
                  type="button"
                  className="btn btn-info pull-right"
                  onClick={this.props.navigator.requestClusterManagement}
                >
                  <span className="glyphicon glyphicon-chevron-left" /> Clusters
                </button>
              </div>
              <div className="col-sm-4">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control pull-left"
                  onChange={this.props.updateSearchState}
                  value={this.props.loadData.search}
                />
              </div>
            </div>
          </div>

          <div className="table registered-devices-list">
            <DevicesList 
              devices={devices}
              onSort={updateSortState}
              sortBy={sort}
              isSortAsc={sortAsc}
              onAdd={updateClusterDevice}
            />
          </div>
        </div>

        <div className="create-cluster-overview pull-right">
          <div className="cluster-management-devices-list">
            <form>
              {serverError}
              {success}

              <div className="form-group col-xs-12 remove-padding bluedotColor">
                <label htmlFor="clusterName" className="pull-left">
                  Cluster name *
                </label>
                <input
                  type="text"
                  className="pull-left form-control"
                  id="clusterName"
                  name="clusterName"
                  placeholder="Cluster name"
                  value={this.props.loadData.clusterName}
                  onChange={this.props.updateFormState}
                />
                { this.props.loadData.errorField == "clusterName" ? errorMessage : "" }
              </div>

              <div className="form-group col-xs-12 remove-padding bluedotColor">
                <label htmlFor="clusterComments" className="pull-left">
                  Comments
                </label>
                <textarea
                  id="clusterComments"
                  className="create-cluster-comments form-control"
                  rows="5"
                  placeholder="Comments ..."
                  name="clusterComments"
                  value={this.props.loadData.clusterComments}
                  onChange={this.props.updateFormState}
                />
              </div>
            </form>

            <button
              type="button"
              className="btn btn-primary pull-right mainDivSubmit"
              onClick={this.props.handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
        <div className="added-devices-list-container pull-right">
          <div className="search-device-list">
            <div className="row">
              <div className="col-sm-6">
                <span className="block-heading">
                  Added Devices ({selectedDevices.length || 0})
                </span>
              </div>
            </div>
          </div>
          <SelectedDevicesList 
            devices={selectedDevices}
            onSort={updateSortState}
            sortBy={sort}
            isSortAsc={sortDevicesAsc}
            onRemove={removeDevice}
          />
        </div>
      </div>
    ); //return
  } //render
} //CreateCluster

export default CreateCluster;
